import { BaseIcon } from '../BaseIcon';
import type { SizedIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums/IconSize';

export type HelpIconProps = Omit<SizedIconProps, 'children'>;

export const HelpIcon = ({ size, ...props }: HelpIconProps) => {
  const SizedHelpIcon = ({ sizeInPixels }: { readonly sizeInPixels: number }) => (
    <BaseIcon width={sizeInPixels} height={sizeInPixels} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4ZM12 17C11.4 17 11 16.6 11 16C11 15.4 11.4 15 12 15C12.6 15 13 15.4 13 16C13 16.6 12.6 17 12 17ZM13.5 12.4C13 12.7 13 12.8 13 13V14H11V13C11 11.7 11.8 11.1 12.4 10.7C12.9 10.4 13 10.3 13 10C13 9.4 12.6 9 12 9C11.6 9 11.3 9.2 11.1 9.5L10.6 10.4L8.9 9.4L9.4 8.5C9.9 7.6 10.9 7 12 7C13.7 7 15 8.3 15 10C15 11.5 14.1 12 13.5 12.4Z"
      />
    </BaseIcon>
  );

  if (size === IconSize.Mini) {
    return <SizedHelpIcon sizeInPixels={18} />;
  }

  return <SizedHelpIcon sizeInPixels={24} />;
};

HelpIcon.displayName = 'HelpIcon';
